import React, { useEffect } from "react";
import { tagManagerParamsEvents } from "../utils/GoogleTagManager";
import EventsName from "../constants/EventsName";
import { NavigateToHome, sha256Hash } from "../utils/CommonFunctions";
import { useNavigate } from "react-router-dom";

const JazzCashCallBackScreen = () => {
  const navigate = useNavigate();
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);
  const status = searchParams.get("status") ? searchParams.get("status") : "1";
  const message = searchParams.get("message")
    ? searchParams.get("message")
    : "";
  const plan_name = searchParams.get("plan_name")
    ? searchParams.get("plan_name")
    : "";
  const msisdn = searchParams.get("msisdn") ? searchParams.get("msisdn")?.slice(-10) : "";
  const utm_source = searchParams.get("utm_source")
    ? searchParams.get("utm_source")
    : "";

  useEffect(() => {
    console.log(url, status, message, plan_name, msisdn);
    if (status === "0") {
      const phone_number = sha256Hash("+92" + msisdn);
      const external_id = sha256Hash("ff-" + msisdn);

      let eventParams = {
        planName: plan_name?.toLowerCase(),
        utm_source: utm_source,
        phone_number: phone_number,
        external_id: external_id,
      };

      tagManagerParamsEvents(EventsName.subscribeJazzCash, eventParams);

      setTimeout(() => {
        navigate("/jc-response", { state: { success: true } });
        // NavigateToHome();
      }, 3000);
    } else {
      navigate("/jc-response",{ state: { success: false } });
      // NavigateToHome();
    }
  }, []);

  return <></>;
};

export default JazzCashCallBackScreen;
